<template>
  <base-dialog-vue
    v-if="showErrorDialog"
    @close="closeDialog"
    title="Invalid Input"
  >
    <template #default>
      <p>What are you doing?</p>
    </template>
    <template #actions>
      <base-button-vue @click="closeDialog">Okie Dokie!</base-button-vue>
    </template>
  </base-dialog-vue>
  <base-card-vue>
    <form @submit.prevent="submitResource">
      <div class="form-control">
        <label for="title">Title</label>
        <input id="title" name="title" type="text" ref="title" />
      </div>
      <div class="form-control">
        <label for="test">Test</label>
        <input id="test" name="test" type="text" v-model.lazy.trim="testData" />
        <p>{{ viewMe }}</p>
      </div>
      <div class="form-control">
        <label for="description">Description</label>
        <textarea
          name="description"
          id="description"
          rows="3"
          ref="description"
        ></textarea>
      </div>
      <div class="form-control">
        <label for="link">Link</label>
        <input id="link" name="link" type="text" ref="link" />
      </div>
      <div>
        <base-button-vue type="submit">Add Resource</base-button-vue>
      </div>
    </form>
  </base-card-vue>
</template>

<script>
export default {
  inject: ['addNewResource'],
  data() {
    return {
      showErrorDialog: false,
      testData: 'Thor',
    };
  },
  computed: {
    viewMe() {
      return this.testData;
    },
  },
  methods: {
    submitResource() {
      const resource = {
        id: new Date().toISOString(),
        title: this.$refs.title.value,
        description: this.$refs.description.value,
        link: this.$refs.link.value,
      };
      if (
        resource.title.trim() === '' ||
        resource.description.trim() === '' ||
        resource.link.trim() === ''
      ) {
        this.showErrorDialog = true;
        return;
      }
      console.log('SUBMIT', resource);
      // this.$emit('add-resource', resource);
      this.addNewResource(resource);
      this.$refs.title.value = '';
      this.$refs.description.value = '';
      this.$refs.link.value = '';
    },
    closeDialog() {
      this.showErrorDialog = false;
    },
  },
};
</script>

<style scoped>
label {
  font-weight: bold;
  display: block;
  margin-bottom: 0.5rem;
}

input,
textarea {
  display: block;
  width: 100%;
  font: inherit;
  padding: 0.15rem;
  border: 1px solid #ccc;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: #3a0061;
  background-color: #f7ebff;
}

.form-control {
  margin: 1rem 0;
}
</style>
